import { render } from "./Clients.vue?vue&type=template&id=94794cf8&scoped=true"
const script = {}

import "./Clients.vue?vue&type=style&index=0&id=94794cf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94794cf8"

export default script